import { VideoData } from '@lumen5/luminary';
import { z } from 'zod';

import type { ToolExecutionContext } from '../types';

import { VideoStateTool } from './VideoStateTool';

import { checkpointVideo } from 'js/src/data/video-data';
import { saveRawLuminary } from 'js/src/luminary';

export const setAspectRatioSchema = z.object({
    aspect_ratio: z.enum(VideoData.ALL_ASPECT_RATIOS),
});
export type SetAspectRatioArgs = z.infer<typeof setAspectRatioSchema>;

export class SetAspectRatioTool extends VideoStateTool<typeof setAspectRatioSchema> {
    public static readonly toolName = 'set_aspect_ratio';

    protected override readonly schema = setAspectRatioSchema;
    protected override readonly toolName = SetAspectRatioTool.toolName;
    protected override readonly toolDescription = 'Set the aspect ratio for the video';

    public override getToolDisplayName(): string {
        return 'Setting aspect ratio';
    }

    public get statusIcon(): string {
        return 'aspect_ratio';
    }

    public async execute(args: SetAspectRatioArgs, context: ToolExecutionContext) {
        const { aspect_ratio } = args;
        const { parentActionGroup } = context;

        try {
            // Set the aspect ratio using the enum
            this.luminary.aspectRatio = aspect_ratio;

            // Save changes to enable undo/redo functionality
            // NOTE: we can not save luminary without any scenes as it's considered an invalid state (for the frontend)
            if (this.luminary.scenes.length > 0) {
                this.dispatch(
                    checkpointVideo({
                        video_data: saveRawLuminary(this.luminary),
                        systemTriggered: false,
                        parentActionGroup,
                    }),
                );
            }

            return `Success: Set video aspect ratio to ${aspect_ratio}`;
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            return `Error setting aspect ratio: ${errorMessage}`;
        }
    }
}
